import { create } from "zustand";

/**
 * Сброс режима перевода при уходе с экрана (план, 11).
 *
 * Зачем отдельное состояние, если у каждой кнопки есть свой `useState`. Потому
 * что вкладки приложения не размонтируются: React Query и переходы держат
 * экраны живыми (так задумано — чтобы возврат был мгновенным). Если бы режим
 * жил только в компоненте, человек, включив перевод на «Задачах», уходил в
 * «Чек-лист» и возвращался — и находил задачу всё ещё переведённой. Он уже
 * забыл, что нажимал: подмена текста, о которой не помнишь, — это баг.
 *
 * Поэтому `epoch` — счётчик переходов. Каждый компонент запоминает, при каком
 * значении он включил перевод, и при изменении снимает режим сам. Один общий
 * счётчик вместо перечисления всех экранов: новый экран получает поведение
 * даром, ничего не регистрируя.
 */
interface TranslateAssistState {
  epoch: number;
  /** Вызывается при смене раздела/вкладки. */
  bump: () => void;
}

export const useTranslateAssist = create<TranslateAssistState>((set) => ({
  epoch: 0,
  bump: () => set((s) => ({ epoch: s.epoch + 1 })),
}));

/** Снять режим перевода во всём приложении (смена вкладки, выход, вход). */
export function resetTranslationAssist(): void {
  useTranslateAssist.getState().bump();
}
